import React from 'react';
import { AwardIcon, CircleCheckBigIcon, FlameIcon, HeartIcon, MessageCircleIcon, TrendingUpIcon, UserPlusIcon } from 'lucide-react';
import { Avatar } from './Avatar';
import { CheckGlyph, CommentGlyph, FollowGlyph, HeartGlyph, ProgressGlyph, StreakGlyph, TrophyGlyph } from './icons/BeelyvIcons';
import { findPerson } from '../data/people';
import { useLocale } from '../contexts/LocaleContext';
import type { NotificationEntry, NotificationKind } from '../types';
const icons: Record<NotificationKind, React.ComponentType<{
  size?: number;
}>> = {
  check: CheckGlyph,
  streak: StreakGlyph,
  review: ProgressGlyph,
  badge: TrophyGlyph,
  like: HeartGlyph,
  comment: CommentGlyph,
  follow: FollowGlyph,
  achievement: TrophyGlyph
};
export function NotificationItem({
  entry,
  priority = false
}: {
  entry: NotificationEntry;
  /** Health notifications carry the stronger treatment. */
  priority?: boolean;
}) {
  const {
    t,
    tl
  } = useLocale();
  const Icon = icons[entry.kind];
  const actor = entry.actorId ? findPerson(entry.actorId) : null;
  return <li className={`flex items-start gap-2 border-b border-sand-line py-2 last:border-b-0 ${entry.unread ? '' : 'opacity-75'}`} data-id="element-1071" data-mp="24070rncg6n5o">
      {actor ? <Avatar src={actor.avatar} name={actor.name} size={36} data-id="element-1072" data-mp="1p9q1oanac9by" /> : <span className={`grid h-9 w-9 shrink-0 place-items-center rounded-[12px] ${priority ? 'bg-deep text-gold' : 'bg-sand-deep text-soft'}`} data-id="element-1073" data-mp="1u8uct6trsh4x">
          <Icon size={17} data-id="element-1074" data-mp="1lbjytdpkidwb" />
        </span>}

      <div className="min-w-0 flex-1" data-id="element-1075" data-mp="16cycxloz520i">
        <p className={`text-[13px] leading-snug ${priority ? 'font-medium text-deep' : 'text-deep'}`} data-id="element-1076" data-mp="16dzxqhvsl2vf">
          {actor && <span className="font-medium" data-id="element-1077" data-mp="30qzb04cp9kzj">{actor.name} </span>}
          {tl(entry.text)}
        </p>
        <p className="mt-[2px] text-[11px] text-muted" data-id="element-1078" data-mp="35pk99y8e5ulc">
          {t('post.hoursAgo', {
          n: entry.hoursAgo
        })}
        </p>
      </div>

      {entry.unread && <span className="mt-2 h-[7px] w-[7px] shrink-0 rounded-pill bg-gold" aria-label={t('notifications.unread')} data-id="element-1079" data-mp="349yf6n58mxas" />}
    </li>;
}